// import ru from './ru';
import en from './en';

const locales = {
  // ru,
  en,
};

export default locales;
